const icon = require('vue-svgicon');
icon.register({
    'requests-new': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" d="M15 8.889a3.89 3.89 0 11.001-7.779 3.89 3.89 0 010 7.779z" _fill="#C70E00"/><path pid="1" d="M2.223 5.556v10c0 1.227.994 2.222 2.222 2.222h10a2.222 2.222 0 002.222-2.222V10h1.11v5.556a3.334 3.334 0 01-3.333 3.333h-10a3.334 3.334 0 01-3.333-3.333v-10a3.333 3.333 0 013.334-3.334H10v1.111H4.445a2.222 2.222 0 00-2.222 2.223z" _fill="currentColor"/>`,
    },
});
